import * as THREE from 'three'
import { ModelBodySceneRegistry } from './ModelBodySceneRegistry'

/** 按场景隔离统一实体注册表，随 Scene 生命周期自动释放引用。 */
const registryByScene = new WeakMap<THREE.Object3D, ModelBodySceneRegistry>()

/**
 * 获取或创建指定场景的统一实体注册表。
 *
 * @param scene Viewer 场景或测试作用域根。
 * @returns 场景唯一注册表。
 */
export function resolveModelBodySceneRegistry(scene: THREE.Object3D): ModelBodySceneRegistry {
  const existingRegistry = registryByScene.get(scene)
  if (existingRegistry) {
    return existingRegistry
  }
  const registry = new ModelBodySceneRegistry(scene)
  registryByScene.set(scene, registry)
  return registry
}

/**
 * 释放并注销指定场景的统一实体注册表。
 *
 * @param scene Viewer 场景或测试作用域根。
 */
export function disposeModelBodySceneRegistry(scene: THREE.Object3D): void {
  registryByScene.get(scene)?.dispose()
  registryByScene.delete(scene)
}
